export default __webpack_public_path__ + "static/media/icon_tiktok.107eee91.svg";